const state = () => ({
  isValid: false,
  time: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  time(state) {
    return state.time;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateTime(state, payload) {
    state.time = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateTime({ commit }, payload) {
    commit('updateTime', payload);
  }
};

export const time = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
